import gql from 'graphql-tag'

export const LOGIN = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      isSuccessful
      message
      data {
        token
        domainName
        payload
        canLogin
      }
    }
  }
`

export const GET_AUTH = gql`
  query Auth {
    auth {
      isSuccessful
      message
      auth {
        access
        fullname
        groups {
          mgroupId
          vgroups {
            id
            name
          }
        }
      }
    }
  }
`

export const EMAIL_TO = gql`
  mutation EmailForgotPassword($input: EmailForgotPasswordInput) {
    emailForgotPassword(input: $input) {
      isSuccessful
      message
      emailForgotPassword {
        message
      }
    }
  }
`

export const OTP_CHECK = gql`
  mutation CheckingOtpPassword($input: CheckingOtpPasswordInput) {
    checkingOtpPassword(input: $input) {
      isSuccessful
      message
      checkingOtpPassword {
        message
      }
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation ResetPasswordOtp($input: ResetPasswordOtpInput) {
    resetPasswordOtp(input: $input) {
      isSuccessful
      message
      resetPasswordOtp {
        message
        users {
          companyName
          fullname
          email
          accessRight
          userId
        }
      }
    }
  }
`

export const GET_PAYLOAD = gql`
  query GetPayload {
    getPayload {
      isSuccessful
      message
      payload {
        payload
      }
    }
  }
`

export const VSMS_V1 = gql`
  mutation BackToVsmsV1($input: BackToVsmsV1Input!) {
    backToVsmsV1(input: $input) {
      isSuccessful
      message
      backToVsmsV1 {
        message
      }
    }
  }
`
